import {Response} from "@/hooks/services/queries/types";
import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import logger from "@FRAMEWORK/utils/logger";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

type GlobalGoodsFlag = {
	[key: string]: {
		[goodsCd: string]: string;
	}[];
};

/** ```
 * 공통 텍스트 배너조회 API
 *   `/api/bff/link/global/goodsList`
 * parameter
 *      types: string (ex)"live,pang" 여러 타입 조회시 콤마(,)로 구분)
 * ```*/
const key = "useGlobalGoodsFlag";
const getPath = (): string | null => `${process.env.ENV_SUPPORT_URL}/api/bff/link/global/goodsList`;

/** ```
 * 공통 텍스트 배너조회 API
 *   `/api/bff/link/global/goodsList`
 * parameter
 *      type: string (ex)"PKG,HOTEL,AIR,TOUR" 여러 타입 조회시 콤마(,)로 구분)
 * ```*/
const useGlobalGoodsFlag = (type = "PKG", options?: Partial<UseQueryOptions<Response<GlobalGoodsFlag>, Error>>) => {
	try {
		return useQuery({
			queryKey: [key, type, getPath()],
			queryFn: () => useConfigureAxios({url: getPath(), method: "POST", data: {type}}).then(r => r.data),
			throwOnError: false,
			...options,
		});
	} catch (error) {
		logger.error(error);
	}
};
export default useGlobalGoodsFlag;
export {getPath};
export type {GlobalGoodsFlag};
